import { useDisclosure } from "@/hooks";
import { useCallback, useState } from "react";

export function useCsvImport<T = unknown>(initial: T[]) {
	const [data, setData] = useState<T[]>(initial);
	const warning = useDisclosure();
	const fileDlg = useDisclosure();

	const clearData = useCallback(() => setData(initial), [initial]);

	const openPipeline = () => warning.onOpen();
	const continuePipeline = () => {
		warning.onClose();
		fileDlg.onOpen();
	};

	return {
		data,
		continuePipeline,
		openPipeline,
		setData,
		warning,
		fileDlg,
		clearData,
	};
}
